import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let StockEventsDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-stockchart-stockevents';
        }
    }
});
export const StockEventsPlugin = {
    name: 'e-stockchart-stockevents',
    install(Vue) {
        Vue.component(StockEventsPlugin.name, StockEventsDirective);
    }
};
export let StockEventDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-stockchart-stockevent';
        }
    }
});
export const StockEventPlugin = {
    name: 'e-stockchart-stockevent',
    install(Vue) {
        Vue.component(StockEventPlugin.name, StockEventDirective);
    }
};
